import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const NAV = [
  { path: '/admin/dashboard', icon: '📊', label: 'Dashboard' },
  { path: '/admin/clients', icon: '👥', label: 'Clients' },
  { path: '/admin/deleted', icon: '🗑️', label: 'Deleted (Recovery)' },
  { path: '/admin/plans', icon: '📦', label: 'Plan Pricing' },
  { path: '/admin/revenue', icon: '💰', label: 'Revenue' },
  { path: '/admin/activity', icon: '📋', label: 'Activity Logs' },
  { path: '/admin/bank-transfers', icon: '🏦', label: 'Bank Transfers' },
  { path: '/admin/invoices',       icon: '🧾', label: 'All Invoices' },
  { path: '/admin/tickets', icon: '🎫', label: 'Support Tickets' },
  { path: '/admin/settings', icon: '⚙️', label: 'Settings' },
];

export default function AdminLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const handleLogout = () => { logout(); navigate('/admin'); };
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('theme') !== 'light');
  useEffect(() => {
    document.body.classList.toggle('light-mode', !darkMode);
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: darkMode ? '#0A0A0A' : '#F2F4F7' }}>
      {/* Sidebar */}
      <div style={{ width: 240, background: darkMode ? '#080808' : '#fff', borderRight: `1px solid ${darkMode ? 'rgba(46,204,113,0.08)' : 'rgba(0,0,0,0.08)'}`, display: 'flex', flexDirection: 'column', position: 'fixed', top: 0, left: 0, bottom: 0 }}>
        {/* Logo */}
        <div style={{ padding: '20px 18px', borderBottom: '1px solid rgba(46,204,113,0.06)' }}>
          <div style={{ marginBottom: 8 }}>
            <span style={{ fontSize: 20, fontWeight: 900, color: '#2ECC71', letterSpacing: -0.5 }}>MARK</span>
            <span style={{ fontSize: 11, fontWeight: 500, color: '#555', marginLeft: 6 }}>Ms Discoveries</span>
          </div>
          <div style={{ display: 'inline-block', background: 'rgba(46,204,113,0.1)', border: '1px solid rgba(46,204,113,0.2)', borderRadius: 20, padding: '2px 10px', fontSize: 9, fontWeight: 900, color: '#2ECC71', letterSpacing: 2 }}>SUPER ADMIN</div>
        </div>

        <nav style={{ flex: 1, padding: '10px 6px', overflowY: 'auto' }}>
          {NAV.map(item => {
            const active = location.pathname === item.path;
            return (
              <Link key={item.path} to={item.path} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', borderRadius: 9, marginBottom: 1, textDecoration: 'none', background: active ? 'rgba(46,204,113,0.1)' : 'transparent', color: active ? '#2ECC71' : '#555', fontWeight: active ? 700 : 400, fontSize: 13, borderLeft: `2px solid ${active ? '#2ECC71' : 'transparent'}`, transition: 'all 0.15s' }}
                onMouseEnter={e => { if (!active) { e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; e.currentTarget.style.color = '#ccc'; } }}
                onMouseLeave={e => { if (!active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#555'; } }}>
                <span style={{ fontSize: 15 }}>{item.icon}</span><span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div style={{ padding: '10px 6px', borderTop: '1px solid rgba(46,204,113,0.06)' }}>
          <div style={{ padding: '8px 12px', marginBottom: 6, fontSize: 11, color: '#444', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.email}</div>
          <button onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '8px 12px', background: 'none', border: 'none', color: '#444', fontSize: 13, cursor: 'pointer', borderRadius: 9, transition: 'all 0.15s' }}
            onMouseEnter={e => { e.currentTarget.style.color = '#E74C3C'; e.currentTarget.style.background = 'rgba(231,76,60,0.07)'; }}
            onMouseLeave={e => { e.currentTarget.style.color = '#444'; e.currentTarget.style.background = 'none'; }}>
            <span>🚪</span><span>Logout</span>
          </button>
        </div>
      </div>

      {/* Main */}
      <div style={{ flex: 1, marginLeft: 240 }}>
        <div style={{ background: darkMode ? '#080808' : '#fff', borderBottom: `1px solid ${darkMode ? 'rgba(46,204,113,0.06)' : 'rgba(0,0,0,0.08)'}`, padding: '13px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 40 }}>
          <div style={{ fontSize: 13, color: darkMode ? '#555' : '#888' }}>
            <span style={{ marginRight: 6 }}>{NAV.find(n => n.path === location.pathname)?.icon}</span>
            {NAV.find(n => n.path === location.pathname)?.label}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <button onClick={() => setDarkMode(d => !d)} title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
              style={{ background: darkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.07)', border: 'none', borderRadius: 20, padding: '5px 12px', cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', gap: 6, color: darkMode ? '#ccc' : '#444', transition: 'all 0.2s' }}>
              {darkMode ? '☀️' : '🌙'}
              <span style={{ fontSize: 11, fontWeight: 600 }}>{darkMode ? 'Light' : 'Dark'}</span>
            </button>
            <span style={{ fontSize: 11, color: '#2ECC71', fontWeight: 700 }}>● Super Admin</span>
          </div>
        </div>
        <div style={{ padding: '28px 32px', background: darkMode ? '#0A0A0A' : '#F2F4F7', minHeight: 'calc(100vh - 50px)' }}>{children}</div>
      </div>
    </div>
  );
}
